import React,{ useEffect, useState } from "react";

import PropTypes from 'prop-types';
import { useLocation } from "react-router-dom";

export default function MenuIcon({ defaultIcon, selected, hover, isSelected, isButtonHover }) {
    const location = useLocation();
    let [img, setImg] = useState(defaultIcon);
    const [isHover, setIsHover] = useState(false);
    useEffect(() => { 
        updateImage()
     }, [location.pathname,isSelected,isHover,setImg,isButtonHover])
    const mouseOverImg = () => {
       setIsHover(true)
    }
    const mouseOutImg = () => {
        setIsHover(false)
    }
    const updateImage = () => {
      if(isSelected){
        setImg(selected)
      }
      else if(isHover||isButtonHover){
        setImg(hover)
      }
      else{
        setImg(defaultIcon)
      }
    }
    return (
        <img
            style={{marginRight: '7px'}}
            onMouseOver={mouseOverImg}
            onMouseLeave={mouseOutImg}
            onFocus={mouseOverImg}
            src={img}
            alt="icon"
        />
    )
}
MenuIcon.propTypes = {
  defaultIcon: PropTypes.elementType,
  selected: PropTypes.elementType,
  hover: PropTypes.elementType,
  isSelected : PropTypes.bool
}